import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppBarTitleService, ApplicationStage, OptInResponseDto, RenewalEligibilityDto } from 'common';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ProductCode } from '../../loan/domain/models/loan.model';
import { RenewalService } from '../../renewal/renewal.service';

@UntilDestroy()
@Component({
    selector: 'ifp-renewal-eligible-reminder',
    templateUrl: './renewal-eligible-reminder.component.html',
    styleUrls: ['./renewal-eligible-reminder.component.scss'],
    standalone: false
})
export class RenewalEligibleReminderComponent implements OnInit {

  public elibility: RenewalEligibilityDto;

  constructor(
    private router: Router,
    private appBarTitleService: AppBarTitleService,
    private renewalService: RenewalService
  ) {
    sessionStorage.setItem('renewalEligibilityPageViewed', JSON.stringify(true));
  }

  get ProductCode() { return ProductCode; }

  ngOnInit() {
    this.appBarTitleService.title = "Renew your loan";
    this.renewalService.obsCurrentrenewalEligibility
      .pipe(untilDestroyed(this))
      .subscribe(data => this.elibility = data);
  }

  optIn() {
    this.renewalService.putOptIn(this.elibility?.loanId)
      .subscribe((data: OptInResponseDto) => {
        if (data?.renewalApplicationStage === ApplicationStage.ApplicationIncomplete) {
          this.renewalService.optInChanged.next(data);
          this.router.navigate([`account/${data?.loanId}/renewal/documents`]);
        } else {
          this.router.navigate(['dashboard']);
        }

      });
  }

}
